/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit InlineNoteEditor/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import EditableTextArea from 'DesignSystem/EditableTextArea/react'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function InlineNoteEditor({
  children,
  viewPath = "/DesignSystem/InlineNoteEditor",
  containerId,
  width = "auto",
  marginTop,
  marginBottom = 0,
  height = "auto",
  overflowY = "auto",
  value,
  onChange,
  autocomplete,
  onAutocompleteAction,
  onAutocompleteFetch,
  toolbarPersist
  
}) {
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let marginTopOrdtSpaceXs = marginTop ?? dtSpaceXs
  return (<React.Fragment
>
<div
  data-testid="InlineNoteEditor.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<div
  data-testid="InlineNoteEditor.Vertical:1"
  data-view-path={viewPath}
 id={containerId}
 style={{'--w-1-1d2b4d': typeof width === 'number' ? `${width}px` : width}}
 className={`views-block ${styles.Vertical}`}
/>
<div
  data-testid="InlineNoteEditor.Vertical:2"
  data-view-path={viewPath}
 style={{'--bc-2-1d2b4d': dtColorsNeutral200,'--pl-3-1d2b4d': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-4-1d2b4d': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-5-1d2b4d': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-6-1d2b4d': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mt-7-1d2b4d': typeof marginTopOrdtSpaceXs === 'number' ? `${marginTopOrdtSpaceXs}px` : marginTopOrdtSpaceXs,'--mb-8-1d2b4d': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--h-9-1d2b4d': typeof height === 'number' ? `${height}px` : height,'--oy-10-1d2b4d': overflowY}}
 className={`views-block inline-editor ${styles.Vertical1}`}
>
<EditableTextArea
  viewPath={`${viewPath}/EditableTextArea`}
 value={value}
 onChange={onChange}
 toolbar="note_template"
 menubar={false}
 inline={true}
 selector="inline-editor"
 inlineToolbarContainer={containerId}
 autocomplete={autocomplete}
 onAutocompleteAction={onAutocompleteAction}
 onAutocompleteFetch={onAutocompleteFetch}
 toolbarPersist={toolbarPersist}
/>
</div>
</div>
{children}
</React.Fragment>)
}